export default {
    'memberAreaPointsHistory.title': 'イベントポイント収集',
    'memberAreaPointsHistory.point_detail': 'ポイント詳細',
    'memberAreaPointsHistory.event_name': 'イベント名',
    'memberAreaPointsHistory.placeholder.event': 'イベント名を入力してください',
} as Record<string, string>;
